import React from 'react';
import { noteCategories } from './noteCategories';
import { selectedItemStyle } from './componentStyles';

const CategorySelector = ({ selectedCategory, onSelectCategory, maxWidth = 200 }) => {
  const handleCategoryClick = (categoryName, e) => {
    // Prevent form submission and event bubbling
    e.preventDefault();
    e.stopPropagation();
    onSelectCategory(categoryName);
  };

  return (
    <div
      className="grid grid-cols-4 gap-1"
      style={{ maxWidth: `${maxWidth}px` }}
      onClick={e => e.stopPropagation()} // Prevent clicks from bubbling up
    >
      {noteCategories.map((category) => (
        <button
          key={category.name}
          type="button" // Explicitly set button type to prevent form submission
          className={`flex flex-col items-center justify-center p-1.5 rounded hover:bg-gray-100 ${selectedCategory === category.name ? selectedItemStyle : ''
            }`}
          onClick={(e) => handleCategoryClick(category.name, e)}
        >
          {React.cloneElement(category.icon, { size: 20 })}
          <span className="text-[10px] mt-0.5 leading-tight">{category.name}</span>
        </button>
      ))}
    </div>
  );
};

export default CategorySelector;